import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef, useState } from 'react';
import styles from './IconButton.module.css';
import cn from 'classnames';
import { Popover } from '@round/ui-kit';

export type Props = Omit<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'ref'> & {
    hint?: string | null;
};

const IconButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
    const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null);

    return (
        <>
            <button
                {...props}
                ref={(el) => {
                    setButtonRef(el);
                    if (typeof ref === 'function') {
                        ref(el);
                        return;
                    }

                    if (ref) {
                        ref.current = el;
                    }
                }}
                className={cn(styles.button, props.className)}
            >
                {props.children}
            </button>

            <Popover
                disabled={!props.hint}
                anchorElement={buttonRef}
                showOn="hover"
                options={{ placement: 'top', modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
            >
                {() => (
                    <div className={styles.hint}>
                        {props.hint}
                        <div className={styles.arrow} />
                    </div>
                )}
            </Popover>
        </>
    );
});

export default IconButton;
